import AccountCircle from "@mui/icons-material/AccountCircle";
import NorthWestIcon from '@mui/icons-material/NorthWest';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from "@mui/icons-material/Search";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import {
  Autocomplete,
  Avatar,
  Button,
  CircularProgress,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Icon,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { InputBaseProps } from "@mui/material/InputBase";
import Toolbar from "@mui/material/Toolbar";
import { alpha, styled } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { PAGE_ROUTES, ROUTES_PATH } from "../../utils/constants";
import Navbar from "../Drawer/Drawer";
import { isMobile } from "react-device-detect";
import {
  getAllSearchResults,
  getSearchSuggestions,
} from "../../services/APIServices/search.api";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  setSearchResult,
} from "../../store/reducers/search.reducer";
// import './AppBar.scss';
import ashokaChakra from "../../assets/Ashoka_Chakra.svg";
import ashokaChakraBlue from "../../assets/Ashoka_Chakra_blue.svg";
// import textLogoWhite from "../../assets/IndeeFlixLogo-white.png";
import textLogoWhite from "../../assets/IndeeClips-logo.png";
import logoOnly from "../../assets/IndeeFlix-logo-only.png";
import { ColorModeContext } from "../App/App";
import { useAuth } from "../../context/AuthContext";
import { getUser, setUser } from "../../store/reducers/user.reducer";
import ConfirmBtn from "../ConfirmBtn/ConfirmBtn";
import { logoutUser } from "../../pages/UserLogin/AuthSignIn";
import { useDispatch } from "react-redux";
import { setChannel } from "../../store/reducers/channel.reducer";
import { ArrowBack, ArrowForwardIos, Close, Key, Logout, Pages } from "@mui/icons-material";
import NotificationMenu from "../../pages/Notification/NotificationMenu";
import { useTranslation } from "react-i18next";

const drawerWidth = 240;
const isMobileDevice = typeof window !== 'undefined' && window.matchMedia("(pointer: coarse)").matches;

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  lineHeight: 0,
  borderRadius: 50,

  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: isMobileDevice ? "400px" : "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: isMobileDevice ? "400px" : "100%",
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
  },
  "&:focus": {
    borderRadius: 0,
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

interface CustomInputBasePros extends InputBaseProps {
  open?: boolean;
}

const StyledInputBase = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "open",
})<CustomInputBasePros>(({ theme, open }) => ({
  color: "inherit",
  "& .MuiOutlinedInput-root": {
    color: "inherit",
    border: 0,
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: isMobileDevice ? "100%" : "50ch",
    height: "inherit",
    margin: "auto", // Center the input horizontally
    borderRadius: "50px", // Apply border radius of 10px
    [theme.breakpoints.up("md")]: {
      width: isMobileDevice ? "100%" : (open ? `calc(80ch - ${drawerWidth}px)` : "60ch"),
    },
    [theme.breakpoints.down("sm")]: {
      // width: open ? "calc(100% - 48px)" : "calc(100% - 16px)",
      // border: "0.5px solid #ccc",
      paddingLeft: `0.5em`,
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    color: "inherit",
    height: "inherit",
    border: 0,
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: isMobileDevice ? "100%" : "50ch",
    margin: "auto", // Center the input horizontally
    borderRadius: "50px", // Apply border radius of 10px
    [theme.breakpoints.up("md")]: {
      width: isMobileDevice ? "100%" : (open ? `calc(80ch - ${drawerWidth}px)` : "60ch"),
    },
    [theme.breakpoints.down("sm")]: {
      width: open ? "calc(100% - 48px)" : "calc(100% - 16px)",
    },
  },
}));

export default function PrimarySearchAppBar() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);
  const [open, setOpen] = React.useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    // navigate("/userLogin");
  };
  const location = useLocation();
  const dispatch = useDispatch();
  let user = useAppSelector((state) => getUser(state));
  const { t } = useTranslation();

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (location.pathname !== PAGE_ROUTES.SEARCH_PAGE) {
      setSearchOpen(false);
    }
  }, [location.pathname]);

  // SSR-safe: Check authentication on client side only
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsAuthenticated(!!localStorage.getItem("token"));
    }
  }, []);

  interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
  }

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    // ...(open && {
    //   marginLeft: drawerWidth,
    //   width: `calc(100% - ${drawerWidth}px)`,
    //   transition: theme.transitions.create(["width", "margin"], {
    //     easing: theme.transitions.easing.sharp,
    //     duration: theme.transitions.duration.enteringScreen,
    //   }),
    // }),
  }));

  const handleLogout = async () => {
    try {
      const userID = localStorage.getItem("userID");
      const response = await logoutUser(userID, 'videoID');

      // Clear token and user info
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("persist:root")
      dispatch(setChannel(null));
      dispatch(setUser(null));
      navigate("/login");
      navigate(0);
    } catch (error) {
      console.error("Logout failed:", error);
      alert("Logout failed. Please try again.");
    }
  };

  const handleLogin = () => {
    navigate(ROUTES_PATH.LOGIN);
  };

  const handleProfile = () => {
    navigate("profile/" + user?.userID);
  };

  const handleDrawer = () => {
    setOpen(!open);
  };

  const handleBackClick = () => {
    setSearchOpen(!searchOpen);
    navigate(-1);
  };

  const handleEditProfile = () => {
    navigate("/profile");
    handleClose();
  };

  const [isLoggingOut, setIsLoggingOut] = useState(false);

  return (
    <><div id="App-Bar">
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" color="primary" open={open}>
          <Toolbar>
            {!isMobile ? (null
              // <Tooltip title="Menu" arrow>
              //   <IconButton
              //     size="large"
              //     edge="start"
              //     color="inherit"
              //     aria-label="open drawer"
              //     // sx={{ mr: 2, ...(open && { display: "none" }) }}
              //     sx={{ mr: 2 }}
              //   >
              //     <Icon onClick={handleDrawer}>
              //       <img
              //         height="100%"
              //         src={theme.palette.mode === "dark"
              //           ? ashokaChakraBlue
              //           : ashokaChakra}
              //         alt=""
              //         style={{ verticalAlign: "unset" }} />
              //     </Icon>
              //   </IconButton>
              // </Tooltip>
            ) : (searchOpen ? (
              <IconButton color="inherit" onClick={handleBackClick}>
                <ArrowBack />
              </IconButton>
            ) : null
            )}
            {(isMobile && searchOpen) ? (
              null
            ) : (
              <><IconButton size="large" onFocus={(e) => e.target.blur()}>
                <Icon onClick={() => navigate(PAGE_ROUTES.HOME)}>
                  <img
                    height="100%"
                    width="100%"
                    src={logoOnly}
                    alt=""
                    style={{ verticalAlign: "unset", outline: "none" }} />
                </Icon>
                <Icon
                  onClick={() => navigate(PAGE_ROUTES.HOME)}
                  style={{ overflow: "visible" }}
                >
                  <img
                    height="100%"
                    // src={textLogoWhite}
                    src="https://indeeclips.com/thumbnail/video_thumbnail/logo-image.gif"
                    alt=""
                    style={{ verticalAlign: "unset", outline: "none" }} />
                </Icon>
              </IconButton><Box sx={{ flexGrow: 1 }} /></>
            )}

            <Box sx={{ display: { xs: !searchOpen ? "none" : "", md: "flex" } }}>
              <Search className="search-container">
                {!isMobile ? (
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                ) : null}
                <SearchInput />
              </Search>
            </Box>
            <Box
              sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}
            >
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {isMobile ? (
                  <IconButton
                    size="large"
                    edge="end"
                    aria-haspopup="true"
                    onClick={() => { navigate(PAGE_ROUTES.SEARCH_PAGE); setSearchOpen(!searchOpen); }}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                    color="inherit"
                  >
                    <SearchIcon />
                  </IconButton>
                ) : null}
              </Box>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <Tooltip title={t("appearance")} arrow>
                  <IconButton
                    size="large"
                    edge="end"
                    aria-haspopup="false"
                    onClick={colorMode.toggleColorMode}
                    color="inherit"
                  >
                    {theme.palette.mode === "dark" ? (
                      <Brightness7Icon />
                    ) : (
                      <Brightness4Icon />
                    )}
                  </IconButton>
                </Tooltip>
              </Box>

            </Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <NotificationMenu />
            </Box>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <Tooltip title={t("account")} arrow>
                <IconButton
                  id="profile-button"
                  aria-label="account of current user"
                  aria-controls="profile-menu"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  sx={{
                    p: 0,
                    color: "inherit",
                  }}
                >
                  {user ? (
                    <Avatar
                      src={user?.profilePic || undefined}
                      sx={{ width: 25, height: 25 }}
                    >
                      {user?.profilePic ? null : (
                        user?.username?.[0]?.toUpperCase() || <AccountCircle />
                      )}
                    </Avatar>
                  ) : (
                    <AccountCircle />
                  )}
                </IconButton>
              </Tooltip>

              <Menu
                sx={{ mt: "45px" }}
                id="profile-menu"
                anchorEl={anchorEl}
                anchorReference="anchorPosition"
                anchorPosition={{ top: 0, left: typeof window !== 'undefined' ? window.innerWidth : 1024 }}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                aria-labelledby="profile-button"
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {isAuthenticated ? (
                  <Box sx={{ minWidth: "250px" }}>
                    {/* Header with Avatar + Details */}
                    <Box sx={{ padding: "12px" }}>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar
                          src={user?.profilePic || ""}
                          alt={`${user?.firstName} ${user?.lastName}`}
                          sx={{ width: 48, height: 48 }} />
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: "bold",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {`${user?.username}`}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "text.secondary",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {`${user?.firstName} ${user?.lastName}`}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              display: "block",
                              color: "text.secondary",
                            }}
                          >
                            {user?.email}
                          </Typography>
                        </Box>
                      </Stack>
                    </Box>

                    <Divider />

                    {/* Account + Edit Profile */}
                    <MenuItem onClick={handleEditProfile}>
                      <ListItemIcon>
                        <Key fontSize="small" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("account")}
                        secondary={t("userProfile.editProfile")}
                        primaryTypographyProps={{ fontWeight: "bold" }}
                        secondaryTypographyProps={{
                          sx: { fontSize: "0.75rem", color: "text.secondary" },
                        }} />
                    </MenuItem>

                    {/* Logout */}
                    <MenuItem onClick={() => setOpenConfirm(true)}>
                      <ListItemIcon>
                        <Logout fontSize="small" color="error" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("logoutDialog.logout")}
                        secondary={t("logoutDialog.logoutSubtext")}
                        primaryTypographyProps={{ color: "error.main", fontWeight: "bold" }}
                        secondaryTypographyProps={{ sx: { fontSize: "0.75rem", color: "text.secondary" } }} />
                    </MenuItem>
                  </Box>
                ) : (
                  <>
                    {/* Login (when not logged in) */}
                    <MenuItem onClick={handleLogin}>
                      <ListItemIcon>
                        <AccountCircle fontSize="small" color="primary" />
                      </ListItemIcon>
                      <ListItemText
                        primary={t("userLogin.heading")}
                        secondary={t("userLogin.loginSubtext")}
                        primaryTypographyProps={{ color: "primary.main", fontWeight: "bold" }}
                        secondaryTypographyProps={{
                          sx: { fontSize: "0.75rem", color: "text.secondary" },
                        }}
                      />
                    </MenuItem>
                  </>
                )}
              </Menu>
            </Box>
          </Toolbar>
        </AppBar>
        <Navbar isMenuOpen={open} handleDrawerClose={handleDrawer} />
      </Box>
    </div>

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
      >
        <DialogTitle>{t("logoutDialog.logoutConfirmLabel")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("logoutDialog.logoutConfirmation")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="primary" disabled={isLoggingOut}>
            {t("logoutDialog.cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={async () => {
              setIsLoggingOut(true);
              try {
                await handleLogout(); // existing logout logic
              } finally {
                setIsLoggingOut(false);
                setOpenConfirm(false);
              }
            }}
            disabled={isLoggingOut}
            sx={{ minWidth: 100 }}
          >
            {isLoggingOut ? (
              <CircularProgress size={24} sx={{ color: "white" }} />
            ) : (
              t("logoutDialog.logoutConfirm")
            )}
          </Button>
        </DialogActions>
      </Dialog></>
  );
}

// const SearchInput = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   let suggetionReq = useRef<any>(null);
//   const [suggetions, setSuggetions] = useState<any>([]);

//   const handleInput = (value: string) => {
//     if (value.length >= 3) {
//       if (suggetionReq?.current) clearTimeout(suggetionReq?.current);
//       suggetionReq.current = setTimeout(() => {
//         getSearchSuggestions(0, 10, value?.trim()).then((res: any) => {
//           setSuggetions(res);
//         });
//       }, 600);
//     }
//   };

//   const handleSearch = (e: any, value: string) => {
//     e?.preventDefault();
//     if (suggetionReq?.current) clearTimeout(suggetionReq?.current);
//     suggetionReq.current = setTimeout(() => {
//       getAllSearchResults(0, 10, value?.trim())
//         .then((res: any) => {
//           dispatch(setSearchResult(res));
//           navigate(PAGE_ROUTES.SEARCH_PAGE);
//         })
//         .catch(() => {
//           dispatch(setSearchResult([]));
//         });
//     }, 600);
//   };
//   return (
//     <Autocomplete
//       freeSolo
//       autoComplete
//       autoHighlight
//       options={suggetions}
//       onChange={(e: any, v: any) => {
//         handleSearch(e, v);
//       }}
//       renderInput={(params: any) => (
//         <StyledInputBase
//           {...params}
//           onChange={(e) => handleInput(e.target.value)}
//           placeholder="Search…"
//           InputProps={{
//             ...params.InputProps,
//             type: "search",
//             "aria-label": "search",
//           }}
//         />
//       )}
//     />
//   );
// };

const SearchInput = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();
  const [suggestions, setSuggestions] = useState<any[]>([]);

  // ✅ URL se search query le rahe hain (agar available ho)
  const [inputValue, setInputValue] = useState<string>(searchParams.get("query") || "");

  const debounceTimer = useRef<any>(null);

  const handleInput = (value: string) => {
    setInputValue(value);

    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    if (value.trim().length >= 3) {
      debounceTimer.current = setTimeout(() => {
        getSearchSuggestions(0, 10, value.trim()).then((res: any) => {
          setSuggestions(Array.isArray(res) ? res : []);
        });
      }, 500);
    } else {
      setSuggestions([]);
    }
  };

  const handleSearch = (value: string) => {
    if (!value.trim()) return;

    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set("query", value);

    // If filters are already present in URL, keep them
    const videotype = currentParams.get("videotype");
    const duration = currentParams.get("duration");
    const uploadTime = currentParams.get("uploadTime");

    getAllSearchResults(0, 10, value.trim(),
      videotype,
      duration,
      uploadTime,
    )
      .then((res: any) => {
        dispatch(setSearchResult([]));
        dispatch(setSearchResult(res));
        navigate(`${PAGE_ROUTES.SEARCH_PAGE}?${currentParams.toString()}`);
      })
      .catch(() => {
        dispatch(setSearchResult([]));
      });
  };

  useEffect(() => {
    const listener = () => {
      const params = new URLSearchParams(window.location.search);
      const query = params.get("query") || "";
      if (query) handleSearch(query);
    };

    window.addEventListener("searchWithURL", listener);
    return () => window.removeEventListener("searchWithURL", listener);
  }, []);


  return (
    <Autocomplete
      freeSolo
      autoHighlight
      options={suggestions || []}
      inputValue={inputValue}
      onInputChange={(e, value, reason) => {
        if (reason === "input") {
          handleInput(value);
        } else if (reason === "clear") {
          setInputValue("");
          setSuggestions([]);
        }
      }}
      onChange={(e, value, reason) => {
        if (reason === "selectOption") {
          handleSearch(value || "");
          setInputValue(value || "");
        }
      }}
      renderOption={(props, option) => (
        <li {...props} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: isMobileDevice ? "400px" : "100%" }}>
          <SearchIcon sx={{ color: "gray", marginRight: 1 }} />
          <span style={{ flexGrow: 1 }}>{option}</span>
          <NorthWestIcon sx={{ fontSize: 14, color: "gray" }} />
        </li>
      )}
      renderInput={(params: any) => (
        <StyledInputBase
          {...params}
          placeholder={t("search.placeholder")}
          onFocus={() => {
            if (!inputValue.trim()) {
              setSuggestions([]);
            }
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSearch(inputValue);
              e.preventDefault();
            }
          }}
        />
      )}
    />
  );
};